import event, {EVENTS} from "../../lib/event";
import clickElement from "./click-element";
import {BATCH_TIPS_MODE} from '../../lib/constant';
export default function waitNext({tips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    return new Promise((resolve)=>{
        if (!tips) {
            if (mode === BATCH_TIPS_MODE) {
                tips = '完成操作后，然后进入下一步';
            }else {
                tips = '完成操作后，点击下面的「下一步」按钮，进入下一步';
            }
        }
        if (mode) { //在新到引导模式下
            window.stepsRuntime.insertTips(_index, tips, mode === BATCH_TIPS_MODE);
            if (mode === BATCH_TIPS_MODE) {
                resolve();
                return;
            }
        }
        window.stepsRuntime.addContinueButton();
        resolve();
/*
        event.emit(EVENTS.SHOW_NEXT_STEP_BTN);
        setTimeout(()=>{
            clickElement({element: 'div[class="lesson_next-step-btn"]', noModal: true, zIndex: 10000, tips}).then(()=>{
                event.emit(EVENTS.HIDE_NEXT_STEP_BTN);
                resolve();
            });
        }, 200); //让子弹飞一会儿
*/
    });

}
